
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import vuxUpload from '@/components/lyx-components/vux-upload/index.vue'
import { formatDate } from "@/javascript/formatDate"
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
XTextarea,
Group,
XInput,
vuxUpload,
goBack
},
data() {
return {
minHeight: 0,
mainOrderId: this.$route.params.mainOrderId,
orderId: this.$route.params.orderId,
orderData: '',
refundType: this.$route.params.type,
orderType: this.$route.params.orderType,
resIdx: 0,
reasonData: [
{
title: '多拍、错拍、不想要'
}, {
title: '不喜欢，效果不好'
}, {
title: '材质与商品描述不符'
}, {
title: '尺寸、容量与商品描述不符'
}, {
title: '颜色、款式、图案与描述不符'
}, {
title: '质量问题'
}, {
title: '做工粗糙、有瑕疵'
}, {
title: '收到商品少件、破损或污渍'
}, {
title: '空包裹'
}, {
title: '商家发错货'
}, {
title: '假冒品牌'
}, {
title: '其他'
}
],
ressonText: '',
fileList: [],
maxFileLen: 10,
typeKind: 'appFor',
showImage: '',
otherReason: '',
wenSku: [],
checkShow: false,
curCheck: -1,
refundMoney: {},
productIndex: 0,
skuCodes: []
}
},
mounted() {
document.title = "申请退款"
const _this = this
_this.minHeight = document.documentElement.clientHeight
_this.getList(JSON.parse(localStorage.getItem('userInfo')).access_token)
},
methods: {
onEvent(event) {
console.log('on', event)
},
getList(access_token) {
const _this = this
if (_this.orderType == 1) {
_this.$http.get('/api/wtcp-ecrm/comOrderClient/getTicketDetail?access_token=' + access_token + '&mainOrderId=' + _this.mainOrderId + '&orderId=' + _this.orderId).then((res) => {
const data = res.data.data
_this.orderData = data
}).then(() => {
_this.$http.get('/api/wtcp-bics/public/scenic/getOne/' + _this.orderData.relativeId).then(res => {
const data = res.data.data
if (data.fileList.image.all.materials.length > 0) {
_this.showImage = data.fileList.image.all.materials[0].fileUrl
}
})

const param = {
"orderId": _this.orderData.id,
"skuCodes": [_this.orderData.skuCode]
}
_this.getRefundMoney( param )
})
} else if (_this.orderType == 2) {
_this.$http.get('/api/wtcp-ecrm/comOrderClient/getHotelDetail?access_token=' + access_token + '&mainOrderId=' + _this.mainOrderId + '&orderId=' + _this.orderId).then((res) => {
const data = res.data.data
_this.orderData = data
}).then(() => {
_this.$http.get('/api/wtcp-bics/public/hotel/findHotelInfoById/' + _this.orderData.rooms[0].relativeId).then(res => {
const data = res.data.data
if (data.fileList.image.all.materials.length > 0) {
_this.showImage = data.fileList.image.all.materials[0].fileUrl
}
})
_this.orderData.rooms.forEach((item) => {
_this.skuCodes.push(item.skuCode)
})
const param = {
"orderId": _this.orderData.id,
"skuCodes": _this.skuCodes
}
_this.getRefundMoney( param )
})
}
else if (_this.orderType == 4) {
_this.$http.get('/api/wtcp-ecrm/comOrderClient/getGoodDetail?access_token=' + access_token + '&mainOrderId=' + _this.mainOrderId + '&orderId=' + _this.orderId).then((res) => {
const data = res.data.data
data.goods.forEach((item, index) => {
item.commodityAttributes = JSON.parse(item.commodityAttributes)
if (item.orderCommodityId == this.$route.query.index) {
_this.productIndex = index
}
})
_this.orderData = data
}).then(() => {
if (_this.orderData.goods.length > 0) {
_this.orderData.goods.map(item => {
_this.wenSku.push(item.skuCode)
})
_this.skuCodes.push(_this.orderData.goods[_this.productIndex].skuCode)
}
const param = {
"orderId": _this.orderData.id,
"skuCodes": _this.skuCodes
}
_this.getRefundMoney( param )
})
}
},
getRefundMoney( param ) {
const _this = this
let access_token=''
access_token=JSON.parse(localStorage.getItem('userInfo')).access_token
_this.$http.post('/api/wtcp-ecrm/order/common/refundMoney?access_token=' + access_token, param).then((res) => {
if (res.data.status == 1) {
_this.refundMoney = res.data.data
}
})
},
checkOne(data, index) {
const _this = this
_this.checkShow = false
_this.curCheck = index
_this.ressonText = data
},
seleceResonFun(item, index) {
const _this = this
_this.checkShow = true
},
onFileAdd(val) {
this.fileList.push({
fileName: val.fileName,
fileType: val.fileType,
fileUrl: val.filePath
})
},
onFileDel(index) {
this.fileList.splice(index, 1)
},

drawback() {
const _this = this
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.refund(userInfo)
},

refund(info) {
const _this = this

let param = {}
if (_this.orderType == 4) {
var credentialsStrine = ""
for (let i in _this.fileList) {
credentialsStrine = credentialsStrine + _this.fileList[i].fileUrl + ','
}
credentialsStrine = credentialsStrine.substring(0, credentialsStrine.length - 1);
param = {
"afterSaleId": 0,
"applyReason": _this.ressonText,
"goodsStatus": _this.orderData.orderLogistic ? 1 : 0, //有物流信息-已发货，无物流信息-未发货
"orderId": _this.orderData.id,
"refundCredentials": credentialsStrine,
"refundDescription": _this.otherReason,
"serviceType": _this.refundType,   //0-仅退款，1-退货退款
"skuCodes": _this.skuCodes
}
} else if (_this.orderType == 1) {

param = {
"afterSaleId": 0,
"applyReason": "",
"goodsStatus": 0,
"orderId": _this.orderData.id,
"refundCredentials": "",
"refundDescription": "",
"serviceType": 0,
"skuCodes": [_this.orderData.skuCode]
}
} else if (_this.orderType == 2) {

param = {
"afterSaleId": 0,
"applyReason": "",
"goodsStatus": 0,
"orderId": _this.orderData.id,
"refundCredentials": "",
"refundDescription": "",
"serviceType": 0,
"skuCodes": _this.skuCodes
}
}



if (_this.orderType == 4 && _this.ressonText == "") {
alert('请选择退款原因')
} else {
let access_token=''
access_token=JSON.parse(localStorage.getItem('userInfo')).access_token
_this.$http.post('/api/wtcp-ecrm/order/common/refundApply?access_token=' + access_token, param).then((res) => {
if (res.data.status == 1) {

if (_this.orderType == 1 || _this.orderType == 2) {
_this.$router.go(-1)
} else if (_this.orderType == 4) {


_this.$router.push('/refundDeal/' + _this.mainOrderId + '/' + _this.orderId + '/' + _this.orderType + '?index=' + _this.$route.query.index)
}
} else {
alert(res.data.msg)
}
})
}
},
hideCheck() {
const _this = this
_this.checkShow = false
},
formatDate(date) {
return formatDate(date, 'yyyy-MM-dd')
}
}
}
